import { render, staticRenderFns } from "./selectDepartmentTreeDialog.vue?vue&type=template&id=19b71a9c&scoped=true"
import script from "./selectDepartmentTreeDialog.vue?vue&type=script&lang=js"
export * from "./selectDepartmentTreeDialog.vue?vue&type=script&lang=js"
import style0 from "./selectDepartmentTreeDialog.vue?vue&type=style&index=0&id=19b71a9c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b71a9c",
  null
  
)

export default component.exports